import * as React from "react";

const SCROLLABLE_OVERFLOW_VALUES = ["auto", "scroll"];

export function findScrollableAncestor(element: HTMLElement | null): HTMLElement | undefined {
    let ancestor = element?.parentElement ?? undefined;
    while (ancestor) {
        if (SCROLLABLE_OVERFLOW_VALUES.includes(getComputedStyle(ancestor).overflowY)) {
            return ancestor;
        }
        ancestor = ancestor.parentElement ?? undefined;
    }
    return undefined;
}

/**
 * Close an open dropdown when the scrollable container the element is placed in is being scrolled.
 */
export function useCloseDropdownOnScroll(isDropdownOpen: boolean, scrollContainer?: HTMLElement | null) {
    React.useEffect(() => {
        if (!scrollContainer || !isDropdownOpen) {
            return;
        }

        const closeDropdownOnScroll = () => {
            document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape", bubbles: true, cancelable: true }));
        };

        scrollContainer.addEventListener("scroll", closeDropdownOnScroll);

        return () => {
            scrollContainer.removeEventListener("scroll", closeDropdownOnScroll);
        };
    }, [isDropdownOpen, scrollContainer]);
}
